module.exports = __webpack_public_path__ + "b645065be3b21918b41fcff7c9577674.png";